import { ReactNode } from 'react';

import { InlineSvgIds } from 'approot/shared/inline-svg/inline-svg';
import type { ImageCropJsonInput } from '../../../gql/schema-types';
import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';

export enum ImagePickerMode {
  Hero = 'hero',
  Editor = 'editor',
  Default = 'default',
}

export type CropData = ImageCropJsonInput;
export type OldCropData = {
  canvasData: {
    naturalWidth: number;
    naturalHeight: number;
    top: number;
    left: number;
    width: number;
    height: number;
  };
  cropData: {
    x: number;
    y: number;
    width: number;
    height: number;
    scaleX: number;
    scaleY: number;
  };
  zoom: number;
};

export type Props = {
  url: string;
  className?: string;
  label?: ReactNode;
  title?: string;
  cardDetail?: string | string[];
  cardMetaLine?: string;
  contentColour?: string;
  cardPillText?: string;
  cardPillIcon?: InlineSvgIds;
  cardMetaIcon?: InlineSvgIds;
  mode: ImagePickerMode;
  imageRatio?: number;
  images?: ResponsiveImage[] | null;
  onCropChange: (crop: CropData) => void;
  cropValue: CropData | undefined;
  name: string;
  isDisabled?: boolean;
  deleteImage?: () => void;
  imagePickerActions?: ReactNode;
};

// TODO: this will replace the above type
// once the old image-picker component is removed
export type ImageState = {
  imageWidth: number;
  imageHeight: number;
  zoom: number;
  x: number;
  y: number;
};

export const THUMBNAIL_WIDTH = 300;
export const THUMBNAIL_HEIGHT = 360;

export const DEFAULT_EDITOR_PROPS = {
  border: 0,
  color: [255, 255, 255, 1],
  rotate: 0,
  borderRadius: 0,
};

export const THUMBNAIL_VARIANT = 'thumbnail';
export const COVER_VARIANT = 'cover';
